import React from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';
import RocketIllustration from 'svg/illustrations/Rocket';

const AreYouReady = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });

  return (
    <Box>
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={6} data-aos={isMd ? 'fade-right' : 'fade-up'}>
          <Box marginBottom={{ xs: 4, md: 0 }}>
            <Typography variant="h4" fontWeight={700} gutterBottom>
              ¿Listo para transformar el control de gastos de su negocio?
            </Typography>
            <Typography
              color="textSecondary"
              variant="h6"
              sx={{ maxWidth: 540 }}
            >
              Un sistema práctico, fácil de usar y diseñado para crecer con su
              operación. Tome decisiones basadas en datos actualizados.
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={6} container justifyContent="center" alignItems="center" data-aos={isMd ? 'fade-left' : 'fade-up'}>
          <Box height="100%" width="100%" maxHeight={400} display="flex" justifyContent="center" alignItems="center">
            <RocketIllustration width="100%" height="100%" />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AreYouReady;
